import pathify from "vuex-pathify"

// Set options
pathify.options.mapping = "simple"

export default pathify
